var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutarrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8144 36.9096C23.9311 35.6512 28.8585 35.7336 34.0484 35.5828C35.062 35.5535 35.9046 36.3497 35.9352 37.3602C35.9657 38.3713 35.1658 39.2152 34.1523 39.2451C29.231 39.388 24.5478 39.2726 19.6876 40.4669C18.7046 40.7087 17.7093 40.1072 17.4712 39.1254C17.227 38.1442 17.8314 37.1508 18.8144 36.9096Z",
    fill: "#E3DBD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89866 26.2183C16.7019 17.6812 26.7398 9.63738 36.8755 4.01515C37.7608 3.52485 38.8782 3.84421 39.3667 4.72833C39.8552 5.61245 39.5376 6.72858 38.6523 7.21888C28.8525 12.6555 19.1442 20.4349 11.6035 28.69C10.9196 29.4361 9.75954 29.488 9.01463 28.806C8.26972 28.124 8.21481 26.9645 8.89866 26.2183Z",
    fill: "#E3DBD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.375245 24.0537C-0.913082 16.2456 1.28498 8.19749 4.39284 1.09764C4.80193 0.171391 5.88263 -0.251144 6.80461 0.153672C7.7327 0.559098 8.15403 1.64045 7.75104 2.56671C4.91794 9.03276 2.81752 16.3457 3.98984 23.4571C4.1547 24.4548 3.47697 25.3982 2.48172 25.5624C1.48647 25.7273 0.540102 25.0508 0.375245 24.0537Z",
    fill: "#E3DBD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutarrow2);
export default __webpack_public_path__ + "static/media/about arrow-2.8e2733f0cf86a64a2fcb512c687d367d.svg";
export { ForwardRef as ReactComponent };